'use strict';

module.exports = function(params) {
    return Odigeo._.map(Odigeo._.keys(params), function(key) {
        return {
            query: key,
            actions: params[key],
        };
    });
};
